import React from 'react';

import { Box, Typography } from '@mui/material';

import type { LinkInfoProperties } from './LinkInfo.types';

export const LinkInfo: React.FC<LinkInfoProperties> = ({
  isPending,
  title = '',
  url = '',
  description = '',
  dataTest = 'link_info',
}) => (
  <Box
    data-testid={dataTest}
    sx={{
      flex: 1,
      minWidth: 0
    }}>
    <Typography
      data-testid={`${dataTest}_title`}
      noWrap
      sx={{
        fontWeight: 600,
        fontSize: '13px'
      }}>
      {isPending ? '...' : title || url}
    </Typography>
    <Typography
      data-testid={`${dataTest}_description`}
      sx={{
        fontSize: '12px',
        color: 'text.secondary',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        mt: 0.25
      }}>
      {isPending ? '...' : description || 'Нет описания'}
    </Typography>
  </Box>
);
